import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { PixelRatio, Platform } from 'react-native';
import { Image } from 'expo-image';
import allCountries from './Resources/countries';
import { AnimatedView } from '../Common/AnimatedView';
import { useDirection } from '../../Hooks/UseDirection';
const ratio = 3 - PixelRatio.get();
function getSize(size) {
    if (Platform.OS !== 'android' || ratio === 0) {
        return size;
    }
    if (ratio > 0) {
        return size - size * ratio;
    }
    return size + size * ratio;
}
const style = {
    container: {
        width: getSize(20),
        height: 15,
        overflow: 'hidden',
    },
    image: {
        height: 15,
        width: getSize(5762)
    }
};
const flags = require('../../../Assets/Images/flags.png');
export const CountryView = ({ code, containerStyle }) => {
    const [dir] = useDirection();
    const country = useMemo(() => {
        return allCountries
            .sort((a, b) => a.priority - b.priority)
            .find(x => x.iso2 === code);
    }, [code]);
    const content_style = useMemo(() => {
        const translateX = dir === 'rtl'
            ? getSize(Math.abs((country === null || country === void 0 ? void 0 : country.image_position) || 0))
            : -getSize(Math.abs((country === null || country === void 0 ? void 0 : country.image_position) || 0));
        return Object.assign(Object.assign({}, style.image), { transform: [{ translateX }] });
    }, [style.image, country === null || country === void 0 ? void 0 : country.image_position, dir]);
    return (_jsx(AnimatedView, { style: [containerStyle, style.container], children: !!code && (_jsx(Image, { source: flags, contentFit: "contain", style: content_style })) }));
};
